package com.havn.app.core.media

import androidx.compose.foundation.layout.Box
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.layout.ContentScale
import coil3.compose.AsyncImage

@Composable
actual fun HavnDatabaseImage(
    dataUrl: String?,
    previewDataUrl: String?,
    contentDescription: String?,
    modifier: Modifier,
    contentScale: ContentScale
): Boolean {
    val finalSource = dataUrl?.takeIf { it.isNotBlank() }
    val previewSource = previewDataUrl
        ?.takeIf { it.isNotBlank() }
        ?.takeUnless { it == finalSource }
    val firstSource = previewSource ?: finalSource ?: return false

    Box(modifier = modifier) {
        AsyncImage(
            model = firstSource,
            contentDescription = contentDescription,
            modifier = Modifier.matchParentSize(),
            contentScale = contentScale
        )
        if (finalSource != null && finalSource != firstSource) {
            AsyncImage(
                model = finalSource,
                contentDescription = contentDescription,
                modifier = Modifier.matchParentSize(),
                contentScale = contentScale
            )
        }
    }
    return true
}

actual suspend fun havnPreloadDatabaseImage(
    dataUrl: String?,
    previewDataUrl: String?
): Boolean = !dataUrl.isNullOrBlank() || !previewDataUrl.isNullOrBlank()
